module.exports = __webpack_public_path__ + "img/logo-text.3bcb5c55.svg";